module.exports = {"svg":{"$":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"circle":[{"$":{"cx":"12","cy":"12","r":"12","fill":"#C4C4C4"}}],"path":[{"$":{"d":"M10.1572 6.34326L15.8141 12.0001L10.1572 17.657","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","fill":"#fff"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/information.svg
// module id = ltjg
// module chunks = 2